import { render, staticRenderFns } from "./InputHolder.vue?vue&type=template&id=671de73a&scoped=true"
import script from "./InputHolder.vue?vue&type=script&lang=js"
export * from "./InputHolder.vue?vue&type=script&lang=js"
import style0 from "./InputHolder.vue?vue&type=style&index=0&id=671de73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671de73a",
  null
  
)

export default component.exports